// Clients API — list / create / read / update / delete / star / invite.
import { http } from "./http";
import type {
  Client,
  ClientInput,
  InactiveClientsResponse,
  InviteResponse,
  OkResponse,
} from "./types";

export const clientsApi = {
  list: (starred = false, signal?: AbortSignal) =>
    http.get<Client[]>("/clients", { starred }, signal),
  get: (id: number, signal?: AbortSignal) =>
    http.get<Client>(`/clients/${id}`, undefined, signal),
  /** Clients who have gone QUIET (last_active_at past the inactivity window). */
  inactive: (signal?: AbortSignal) =>
    http.get<InactiveClientsResponse>("/clients/inactive", undefined, signal),
  create: (body: ClientInput) => http.post<Client>("/clients", body),
  update: (id: number, body: ClientInput) =>
    http.patch<Client>(`/clients/${id}`, body),
  remove: (id: number) => http.del<OkResponse>(`/clients/${id}`),
  star: (id: number) => http.post<Client>(`/clients/${id}/star`),
  /** Invite this client to the portal — returns the one-time claim link. */
  invite: (id: number) => http.post<InviteResponse>(`/clients/${id}/invite`),
};
